import { gql } from 'urql';

export const needsBasedQuestionsQuery = gql`
	query needsBasedQuestionnaire($questionnaireId: String!, $language: NonEmptyString! = "en-us") {
		questionnaire(questionnaireId: $questionnaireId, options: { language: $language }) {
			questionnaireId
			questions {
				questionId
				description
				order
				answer {
					__typename
					... on HasPredefinedAnswer {
						answers {
							answerId
							description
						}
						... on HasAnswerFormat {
							format
						}
					}
				}
				answerRequired
				triggers {
					questionId
					answerId
				}
			}
		}
	}
`;

export const filterQuestionsQuery = gql`
	query QuestionnaireBy(
		$visitReason: GeneralVisitReasonType
		$facilityCode: String
		$language: NonEmptyString! = "en-us"
	) {
		questionnaireBy(
			filter: { visitReason: $visitReason, facilityCode: $facilityCode, options: { language: $language } }
		) {
			questionnaireId
			questions {
				questionId
				code
				description
				order
				answer {
					... on MultiChoiceMultiAnswer {
						format
						answers {
							answerId
							description
						}
					}
					... on MultiChoiceSingleAnswer {
						format
						answers {
							answerId
							description
						}
					}
				}
				answerRequired
				sectionType
				triggers {
					questionId
					answerId
				}
			}
		}
	}
`;
